import { useState, useEffect } from 'react';

const useAdblockDetector = () => {
    const [isAdBlocked, setIsAdBlocked] = useState(false);

    useEffect(() => {
        const img = document.getElementById('adblock-detect-img');
        if (img) {
            // Vérifier si l'image a été bloquée en testant sa taille
            const isBlocked = img.naturalHeight === 0 || img.naturalWidth === 0;
            setIsAdBlocked(isBlocked);
        }
    }, []);

    return isAdBlocked;
};

export default useAdblockDetector;